import darkTokens from '@amzn/meridian-tokens/theme/blue-dark';
import lightTokens from '@amzn/meridian-tokens/theme/blue-light';
// import { BLUE_DARK_TOKENS as darkTokens } from './blue-dark';

export const THEME = {
    lightTokens,
    darkTokens,
};
